import { loginApi } from '../../setup/setupApi';
import { ConnectorValues, ConnectProps, SocialConnectionsResponse } from '../social/types';

export const getCrossConnections = (projectId: string): Promise<SocialConnectionsResponse> =>
  loginApi.get(`projects/${projectId}/cross_social_connections`).then((res) => res.data);

export const setPlatformConnection = ({
  projectId,
  provider,
  values
}: ConnectProps): Promise<boolean | ConnectorValues> =>
  loginApi
    .post(`projects/${projectId}/cross_social_connections/${provider}`, values)
    .then((res) => res.data);

export const updatePlatformConnection = ({
  projectId,
  provider,
  values
}: ConnectProps): Promise<boolean | ConnectorValues> =>
  loginApi
    .put(`projects/${projectId}/cross_social_connections/${provider}`, values)
    .then((res) => res.data);

export const disconnectPlatform = ({
  projectId,
  provider
}: ConnectProps): Promise<boolean | ConnectorValues> =>
  loginApi
    .delete(`projects/${projectId}/cross_social_connections/${provider}`)
    .then((res) => res.data);
